// File: TreeService_PaymentPage_v01.tsx
// Description: ReactSetv022026BSSC payment and deposit page for stump removal and tree services.
// Version: v01
// Created: 2026-04-18

import React, { useMemo, useState } from 'react';
import {
  Alert,
  Badge,
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
} from 'react-bootstrap';

import EasyStumpOut_Header from "./EasyStumpOut_Header_v01_active";
import EasyStumpOut_Footer from "./EasyStumpOut_Footer_v01_active";
import { InlinePageStyles } from "../App_STYLES_v01a";

import type { EASY_STUMP_OUT_LOCATION_DATA, ILocationConfig } from "../App_CONFIG_v01a";


type locationConfigProps = {
  locationConfig: ILocationConfig;
};


export interface PaymentOption_v01 {
  id: string;
  label: string;
  amount: number;
  description?: string;
  category: 'deposit' | 'service' | 'other';
}

export interface PaymentProviderConfig_v01 {
  providerName: string;
  iframeTitle: string;
  iframeSrc: string;
  minHeight?: number;
  helperText?: string;
}

export interface TreeServicePaymentPageProps_v01 {
  businessName?: string;
  phone?: string;
  email?: string;
  serviceArea?: string;
  paymentOptions?: PaymentOption_v01[];
  paymentProvider?: PaymentProviderConfig_v01;
  acceptedPaymentNote?: string;
  submitInstructions?: string;
}

// const defaultPaymentOptions_v01: PaymentOption_v01[] = [
//   {
//     id: 'deposit-150',
//     label: 'Standard Scheduling Deposit',
//     amount: 150,
//     description: 'Recommended for most stump grinding and small tree service appointments.',
//     category: 'deposit',
//   },
//   {
//     id: 'deposit-300',
//     label: 'Large Job Deposit',
//     amount: 300,
//     description: 'Good fit for larger stump removal, multiple stumps, or bundled tree work.',
//     category: 'deposit',
//   },
//   {
//     id: 'payment-500',
//     label: 'Partial Payment',
//     amount: 500,
//     description: 'Use for approved progress payments or larger scheduled service blocks.',
//     category: 'service',
//   },
//   {
//     id: 'custom-payment',
//     label: 'Custom Amount',
//     amount: 0,
//     description: 'Enter a custom amount from your invoice or estimate.',
//     category: 'other',
//   },
// ];

// const defaultProvider_v01: PaymentProviderConfig_v01 = {
//   providerName: 'Hosted Payment Formxxx',
//   iframeTitle: 'Secure payment form',
//   iframeSrc: 'https://example.com/payment-provider-hosted-form',
//   minHeight: 720,
//   helperText:
//     'Replace this iframe URL with your hosted payment page from Stripe, Authorize.net, Square, QuickBooks, or another provider.',
// };

// const currencyFormatter_v01 = new Intl.NumberFormat('en-US', {
//   style: 'currency',
//   currency: 'USD',
//   maximumFractionDigits: 2,
// });

// const PaymentProviderFrame_v01: React.FC<{ provider: PaymentProviderConfig_v01 }> = ({ provider }) => {
//   return (
//     <Card className="border-0 shadow-sm rounded-4 overflow-hidden h-100">
//       <Card.Body className="p-0">
//         <div className="px-4 pt-4 pb-2">
//           <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2">
//             <div>
//               <div className="small text-uppercase text-muted fw-semibold">Payment Provider</div>
//               <h3 className="h5 mb-0">{provider.providerName}</h3>
//             </div>
//             <Badge bg="success" className="px-3 py-2 rounded-pill">
//               Secure Hosted Form
//             </Badge>
//           </div>
//           {provider.helperText ? <p className="text-muted mb-3">{provider.helperText}</p> : null}
//         </div>

//         <div className="px-3 pb-3">
//           <div className="border rounded-4 overflow-hidden bg-light">
//             <iframe
//               title={provider.iframeTitle}
//               src={provider.iframeSrc}
//               style={{
//                 width: '100%',
//                 minHeight: `${provider.minHeight ?? 720}px`,
//                 border: '0',
//                 display: 'block',
//                 backgroundColor: '#ffffff',
//               }}
//               loading="lazy"
//               referrerPolicy="strict-origin-when-cross-origin"
//             />
//           </div>
//         </div>
//       </Card.Body>
//     </Card>
//   );
// };

// const TreeService_PaymentPage_v01: React.FC<TreeServicePaymentPageProps_v01> = (
//   {
//     businessName = 'Your Tree Service Company',
//     phone = '(555) 555-5555',
//     email = 'payments@example.com',
//     serviceArea = 'Serving local residential and commercial customers',
//     paymentOptions = defaultPaymentOptions_v01,
//     paymentProvider = defaultProvider_v01,
//     acceptedPaymentNote = 'We can typically support credit cards, debit cards, and provider-specific financing or wallet options depending on your payment integration.',
//     submitInstructions = 'Choose a deposit or payment amount, confirm your job details, and complete the secure hosted payment form below.',
//   }
// ) => {
//   const [selectedOptionId, setSelectedOptionId] = useState<string>(paymentOptions[0]?.id ?? '');
//   const [customAmount, setCustomAmount] = useState<string>('');
//   const [customerName, setCustomerName] = useState<string>('');
//   const [invoiceNumber, setInvoiceNumber] = useState<string>('');
//   const [serviceAddress, setServiceAddress] = useState<string>('');
//   const [notes, setNotes] = useState<string>('');

//   const selectedOption = useMemo(
//     () => paymentOptions.find((option) => option.id === selectedOptionId) ?? paymentOptions[0],
//     [paymentOptions, selectedOptionId]
//   );



  // const selectedAmount = useMemo(() => {
  //   if (!selectedOption) return 0;
  //   if (selectedOption.id === 'custom-payment') {
  //     const parsed = Number(customAmount);
  //     return Number.isFinite(parsed) ? parsed : 0;
  //   }
  //   return selectedOption.amount;
  // }, [customAmount, selectedOption]);



export default function PaymentProviderFrame_v01( {locationConfig}: locationConfigProps) {
  // const PaymentProviderFrame_v01: () => {
  return (
    <main>
      <InlinePageStyles />
      <EasyStumpOut_Header locationConfig={locationConfig} />
            
      <section className="py-5 bg-secondary text-white">
        <Container>
         
          <Row className="align-items-center g-4">
            <Col lg={12}>
              <h1 className="display-5 fw-bold mb-3">Cheyenne Stump Removal Secure payment</h1>
              <p className="lead mb-3">
                Make a secure payment for stump grinding, stump removal, tree trimming, cleanup,
                hauling, emergency tree work, or a scheduling deposit.
              </p>
            </Col>
           
          </Row>
        </Container>
      </section>

      <section className="py-5 bg-white">
        <Container>
          <Row className="g-4">
            <Col xl={12}>
              <Row className="g-4">
                <Col xs={12}>
                      {/* <div className="small text-uppercase text-muted fw-semibold mb-2">Step 3</div> */}
                      <iframe
                          src="https://api.timberlinecloud.com/widget/form/Ll5orJgQ5uLNy5HhRefo"
                          // style={{ width: '100%', height: '100%', border: 'none', borderRadius: '8px',  overflow: 'hidden' }}
                          style={{ width: '100%', height: '1200px', border: 'none',  overflow: 'hidden' }}
                          id="inline-Ll5orJgQ5uLNy5HhRefo" 
                          data-layout="{'id':'INLINE'}"
                          data-trigger-type="alwaysShow"
                          data-trigger-value=""
                          data-activation-type="alwaysActivated"
                          data-activation-value=""
                          data-deactivation-type="neverDeactivate"
                          data-deactivation-value=""
                          data-form-name="Stump Removal Service Form"
                          data-height="1031"
                          data-layout-iframe-id="inline-Ll5orJgQ5uLNy5HhRefo"
                          data-form-id="Ll5orJgQ5uLNy5HhRefo"
                          title="Stump Removal Service Form"
                              >
                      </iframe>
                      <script src="https://api.timberlinecloud.com/js/form_embed.js"></script>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      <EasyStumpOut_Footer locationConfig={locationConfig} />
            
    </main>
  );
};

// export default TreeService_PaymentPage_v01;

// Version Notes: v01
// File Name: TreeService_PaymentPage_v01.tsx
// Quick Description: Provider-agnostic payment page for stump removal and tree services with a swappable hosted iframe section.
// Created: 2026-04-18
